/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Company_Meta_TitleInputs */

const ja_playdata_company_meta_title = /** @type {(inputs: Playdata_Company_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会社概要`)
};

const en_playdata_company_meta_title = /** @type {(inputs: Playdata_Company_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Playdata_Company_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_company_meta_title = /** @type {((inputs?: Playdata_Company_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Company_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_company_meta_title(inputs)
	return en_playdata_company_meta_title(inputs)
});